/* JERARCA — Motion & interactivity
   Respects prefers-reduced-motion throughout */

(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Reveal on scroll ── */
  if (!reduced) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

    /* re-scan after any DOM mutations (e.g. cart drawer, section renders) */
    new MutationObserver(() => {
      document.querySelectorAll('.reveal:not(.in)').forEach((el) => io.observe(el));
    }).observe(document.body, { childList: true, subtree: true });
  } else {
    /* instant reveal for reduced-motion users */
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('in'));
  }

  /* ── Marquee pause on hover ── */
  document.querySelectorAll('.jrq-marquee').forEach((el) => {
    el.addEventListener('mouseenter', () => {
      el.querySelectorAll('.jrq-track').forEach((t) => (t.style.animationPlayState = 'paused'));
    });
    el.addEventListener('mouseleave', () => {
      el.querySelectorAll('.jrq-track').forEach((t) => (t.style.animationPlayState = 'running'));
    });
  });

  /* ── Hero Ken Burns already handled by CSS animation on .hero img.bg ── */
  /* ── Card hover zoom handled by CSS .card:hover .shot img ── */

  /* ── Scroll-cue visibility (hide after first scroll) ── */
  const cue = document.querySelector('.jrq-scrolldown');
  if (cue) {
    const onScroll = () => {
      if (window.scrollY > 60) {
        cue.style.opacity = '0';
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Sticky glass header (home page only) ──
     Switches absolute → fixed the moment the header reaches the viewport top,
     using the parent section's offsetTop as threshold (no visual jump). */
  if (document.body.classList.contains('template-index')) {
    const hw = document.querySelector('.header-wrapper');
    if (hw) {
      const threshold = Math.max(hw.parentElement ? hw.parentElement.offsetTop : 0, 1);
      let ticking = false;
      const updateHeader = () => {
        hw.classList.toggle('header--scrolled', window.scrollY >= threshold);
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
      }, { passive: true });
      updateHeader();
    }
  }
})();
